import { render, staticRenderFns } from "./UpdateRateByRatePlan.vue?vue&type=template&id=1e154bc7"
import script from "./UpdateRateByRatePlan.vue?vue&type=script&lang=js"
export * from "./UpdateRateByRatePlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports